module.exports = __webpack_public_path__ + "img/nihon-kohden_TEC5600.2ee96e13.png";